// Nav
const nav = document.querySelector('.nav');
const items = Array.from(document.querySelectorAll('.nav__menu-item'));
const links = Array.from(document.querySelectorAll('.nav__menu-item a'));
const activeClass = 'active';
const leaveClass = 'leave';
const prevClass = 'prev';
const activeItem = getActiveItem(items);

export const initNav = () => {
  setActiveItemProps(activeItem);

  // Set nav width
  const navWidth = items.reduce((total, item) => total + item.querySelector('span').offsetWidth, 0);
  nav.style.width = `${navWidth * 2}px`;

  // Add event listeners
  items.forEach(item => item.addEventListener('mouseenter', handleItemMouseenter));
  links.forEach(link => link.addEventListener('click', handleLinkClick));
  nav.addEventListener('mouseleave', handleNavMouseleave);
};

function handleItemMouseenter() {
  setActiveItem(this);
}

function handleLinkClick(e) {
  e.preventDefault();

  var hash = e.currentTarget.hash;
  var element = document.querySelector(hash);

  element.scrollIntoView({
    block: 'start',
    behavior: 'smooth',
    inline: 'center'
  });

  document.querySelector('html').style.scrollSnapType = 'none';

  setTimeout(function() {
    document.querySelector('html').style.scrollSnapType = 'y mandatory';
  }, 800);
}

function handleNavMouseleave() {
  const savedActiveItem = items[nav.dataset.active];
  setActiveItem(savedActiveItem);
  items.forEach(item => item.classList.remove(leaveClass));
}

function setActiveItem(item) {
  const prevActiveItem = getActiveItem(items);
  const nextActiveItem = item;

  if (prevActiveItem === nextActiveItem) return;

  if (prevActiveItem) {
    const prevActiveItemText = prevActiveItem.querySelector('span');
    prevActiveItem.classList.remove(activeClass);
    prevActiveItemText.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'opacity') {
        prevActiveItem.classList.remove(leaveClass);
      }
    });
  }

  if (nextActiveItem) {
    nextActiveItem.classList.add(activeClass);
    setActiveItemProps(nextActiveItem);
    setPrevItems(items.indexOf(nextActiveItem));
  }
}

function getActiveItem(items) {
  return items.find(item => item.classList.contains(activeClass));
}

function setActiveItemProps(item) {
  const text = item.querySelector('span');
  nav.style.setProperty('--active-item-width', `${text.offsetWidth - 8}px`);
  nav.style.setProperty('--indicator-x', `${item.offsetLeft}px`);
}

function setPrevItems(activeItemIndex) {
  items.forEach((item, index) => {
    item.classList.toggle(prevClass, index < activeItemIndex);
  });
}

export const setActiveNavItem = () => {
  setTimeout(() => {
    const activeSection = document.querySelector('.section--active');
    const sectionId = activeSection.dataset.section;
    const pageSection = activeSection && sectionId;
    const nextActiveItem = pageSection && items.find(item => item.dataset.item === pageSection);

    if (nextActiveItem) {
      setActiveItem(nextActiveItem);
      nav.dataset.active = items.indexOf(nextActiveItem).toString();
      // Update hash (problematic; fires resize event on iOS)
      // window.history.replaceState({}, '', (sectionId === 'intro' ? location.pathname : `#${sectionId}`));
    }
  }, 500);
}
